var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 8.33594C1.66602 5.57165 3.90173 3.33594 6.66602 3.33594L5.95173 4.76451",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 11.6641C18.332 14.4283 16.0963 16.6641 13.332 16.6641L14.0463 15.2355",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 2.09373C15.9002 1.46479 17.2429 1.6742 17.9709 1.80768C18.1782 1.84568 18.3333 2.0489 18.3333 2.28513V7.66761C18.3333 7.94974 18.115 8.16018 17.8673 8.11638C17.1198 7.98419 15.8305 7.82094 14.375 8.42114C12.8101 9.06639 11.235 9.18781 10.3754 9.16056C10.1616 9.15381 10 8.95215 10 8.7114V3.32629C10 3.04882 10.2127 2.83054 10.4593 2.8353C11.3348 2.85219 12.8597 2.71856 14.375 2.09373Z",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04102 11.2656C7.56628 10.6367 8.90893 10.8461 9.63693 10.9795C9.84418 11.0175 9.99935 11.2208 9.99935 11.457V16.8395C9.99935 17.1216 9.78102 17.332 9.53327 17.2883C8.78577 17.1561 7.49654 16.9928 6.04102 17.593C4.47607 18.2383 2.90099 18.3597 2.04145 18.3324C1.82759 18.3257 1.66602 18.124 1.66602 17.8833V12.4982C1.66602 12.2207 1.87872 12.0024 2.12532 12.0072C3.00083 12.0241 4.52567 11.8904 6.04102 11.2656Z",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 5.41406H14.1735",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 14.5859H5.83951",
    stroke: "#4A5564",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeIcon);
export default __webpack_public_path__ + "static/media/trade-icon.b6757f22.svg";
export { ForwardRef as ReactComponent };